import React,{Component} from 'react'

import Wrapper from '../Wrapper';

import Columns from '../Columns';

import './Merch.less';

const ShopItem = ({title,price,img,link}) => {
  return (
    <a href={link} target="_blank" className='item' >
    <div className='thumb-container'>
      <img src={img} />
    </div>
    <div className='name'>{title}</div>
    <div className='price'>{price} EUR</div>
    </a>
  )
}

class Merch extends Component{

  columnCount = () => {
    const {res} = this.props;

    let ret = 1;

    switch(res){
      case 'xlarge':
        ret = 4;
        break;
      case 'large':
        ret = 3;
        break;
      case 'medium':
        ret = 2;
        break;
      case 'small':
        ret = 1;
        break;
    }

    return ret;
  }

  render(){
    const {res,id} = this.props;
    const {data} = this.props;

    const link = data.social.filter(el => el.network == 'merchcowboy');

    if(!data.merch){
      return false
    }
    return (
      <Wrapper title="Merch" linkText="Offizieller Onlineshop" linkUrl={link[0].url} res={res} id={id}>
      <Columns cols={this.columnCount()} >
          {
            data.merch.map((merch,idx) => <ShopItem key={idx} {...merch} />)
          }
      </Columns>
      </Wrapper>
    )
  }
}

export default Merch



// WEBPACK FOOTER //
// ./src/components/sections/Merch.js